module.exports = __webpack_public_path__ + "media/img/sda/Citibank_Aurora_Dashboard-45a69599c2dab8a2184272b77c48843a.png";